import { inject } from '@angular/core';
import { CanActivateFn } from '@angular/router';
import { MsalService } from '@azure/msal-angular';

/**
 * Functional authentication guard.
 * Synchronous check is safe here because handleRedirectPromise() is guaranteed
 * to have completed inside provideAppInitializer() before any guard ever runs.
 */
export const authGuard: CanActivateFn = (route, state) => {
  const msalService = inject(MsalService);

  // Resolve active account — covers both normal load and page-reload scenarios
  let account = msalService.instance.getActiveAccount();
  if (!account) {
    const accounts = msalService.instance.getAllAccounts();
    if (accounts.length > 0) {
      account = accounts[0];
      msalService.instance.setActiveAccount(account);
    }
  }

  if (account) {
    return true;
  }

  // Block silent-renew iframes
  if (window !== window.parent) {
    return false;
  }

  // If an MSAL interaction is already running, do not start another one.
  const hasInteractionInProgress = Object.keys(sessionStorage)
    .some(k => k.endsWith('.interaction.status'));
  if (hasInteractionInProgress) {
    return false;
  }

  // Persist the intended URL so MainLayoutComponent can redirect after login
  sessionStorage.setItem('redirectUrl', state.url);

  void msalService.instance.loginRedirect({ scopes: ['openid', 'profile'] }).catch((error: any) => {
    if (error?.errorCode !== 'interaction_in_progress') {
      console.error('MSAL loginRedirect failed in auth guard:', error);
    }
  });
  return false;
};
